"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAchPadAllowed = exports.isWithinBankDebitRefundDelay = exports.BANK_DEBIT_REFUND_DELAY_IN_DAYS = exports.isBankDebitPaymentMethod = void 0;
const payment_1 = require("../enums/payment");
const dates_1 = require("./dates");
const isBankDebitPaymentMethod = (paymentMethod) => paymentMethod === payment_1.PaymentMethod.Ach || paymentMethod === payment_1.PaymentMethod.Pad || paymentMethod === payment_1.PaymentMethod.Sepa;
exports.isBankDebitPaymentMethod = isBankDebitPaymentMethod;
exports.BANK_DEBIT_REFUND_DELAY_IN_DAYS = 60;
const isWithinBankDebitRefundDelay = ({ paymentMethod, createdAtUtc, currentUtc = new Date(), }) => (0, exports.isBankDebitPaymentMethod)(paymentMethod) &&
    (0, dates_1.getDatePlusNDays)(createdAtUtc, exports.BANK_DEBIT_REFUND_DELAY_IN_DAYS).getTime() > currentUtc.getTime();
exports.isWithinBankDebitRefundDelay = isWithinBankDebitRefundDelay;
const isAchPadAllowed = ({ currentUtc = new Date(), startUtc, endUtc, }) => {
    const hasMinimumDaysBeforeEvent = (days) => {
        const minDateRequired = (0, dates_1.getDatePlusNDays)(currentUtc, days);
        return endUtc ? new Date(endUtc) >= minDateRequired : startUtc ? new Date(startUtc) >= minDateRequired : true;
    };
    return {
        isPadAllowed: hasMinimumDaysBeforeEvent(10),
        isAchAllowed: hasMinimumDaysBeforeEvent(10),
        isSepaAllowed: hasMinimumDaysBeforeEvent(10),
    };
};
exports.isAchPadAllowed = isAchPadAllowed;
